import * as React from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { Stack } from "@mui/material";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

export default function CreateBillingConfirm(props) {
  const { open, createBilling } = props;
  // const [open, setOpen] = React.useState(false);
  const theme = useTheme();
  const fullScreen = useMediaQuery(theme.breakpoints.down("md"));

  const handleChangeyes = () => {
    createBilling(true);
  };
  const handleChangeno = () => {
    createBilling(false);
  };
  return (
    <>
      <Dialog
        className="user-filter-popup user-filter"
        sx={{ width: "100%" }}
        fullScreen={fullScreen}
        open={open}
        aria-labelledby="responsive-dialog-title"
      >
        <Stack
          sx={{ p: "26px 34px", pb: "4px" }}
          direction="row"
          alignItems="center"
          spacing={2}
          justifyContent="space-between"
        >
          <Typography className="model-title">
            Create Billing Statement
          </Typography>
        </Stack>
        <Box sx={{ p: "0px 34px 0px 34px" }}>
          <p className="label">
            No billing statement found for the selected period.Click the Create
            button below start a billing statement for the selected project in
            the selected period.
          </p>
        </Box>
        <DialogActions
          sx={{ justifyContent: "flex-start", p: "20px 34px", mt: "21px" }}
        >
          <Button className="filter-btn" onClick={handleChangeyes}>
            Create
          </Button>
          <Button className="cancel-btn" onClick={handleChangeno}>
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
